export const defaultField =  {
    field_size: [500, 500],
    objects: [
        { "category": "indicators", "origin": [30, 30], "type": "divider", "template": "default",
          "template": "default", "points": [[470, 30, 470, 30], [470, 470, 470, 470], [30, 470, 30, 470], [30, 30, 30, 30]] },
        { "category": "objects", "origin": [30, 30], "type": "cone", "variation": "red" },
        { "category": "objects", "origin": [470, 30], "type": "cone", "variation": "red" },
        { "category": "objects", "origin": [470, 470], "type": "cone", "variation": "red" },
        { "category": "objects", "origin": [30, 470], "type": "cone", "variation": "red" }
    ]
}

export const field_50 = {
    field_size: [500, 700],
    objects: [
        {
            "category": "indicators",
            "origin": [30, 470],
            "type": "divider",
            "template": "field_50",
            "points": [
                [ 100, 470, 175, 470 ],
                [ 180, 405, 250, 400 ], [ 320, 405, 325, 470 ], [ 250, 470, 175, 470 ], // centre circkle top side
                [ 180, 535, 250, 540 ], [ 320, 535, 325, 470 ], // centre circkle bottom side
                [ 395, 470, 470, 470 ], [ 470, 470, 470, 500 ], [ 470, 235, 470,  30 ], [ 290,  30, 110,  30 ],
                [ 110,  90, 110, 150 ], [ 145, 150, 185, 150 ], [ 250, 200, 315, 150 ], [ 250, 150, 185, 150 ], 
                [ 240, 150, 390, 150 ], [ 390,  90, 390,  30 ],  // penalty area,
                [ 355,  30, 315,  30 ], [ 315,  55, 315,  80 ], [ 250,  80, 185,  80 ], [ 185,  55 , 185, 30 ], //goalkeaper zone
                [ 110,  30,  30,  30 ], [  30, 250,  30, 500 ]
            ] 
        },
        {
            "category": "objects","origin": [ 250, 20 ], "type": "goal", "rotation": 0, "size": "small"
        }
    ]
}

export const field_25 = {
    field_size: [500, 500],
    objects: [
        {
            "category": "indicators",
            "origin": [0, 100],
            "type": "divider",
            "template": "field_25",
            "points": [
                [  25, 100,  25, 100 ], [  25, 200,  25, 300 ], [ 100, 300, 150, 300 ],
                [ 250, 375, 350, 300 ], [ 250, 300, 150, 300 ], [ 300, 300, 475, 300 ],
                [ 475, 200, 475, 100 ], [ 400, 100, 350, 100 ], [ 350, 125, 350, 175 ],
                [ 250, 175, 150, 175 ], [ 150, 125, 150, 100 ], [  75, 100,  25, 100 ],
                [ 275, 100, 500, 100 ]
            ] 
        },
        {
            "category": "objects","origin": [ 250, 90 ], "type": "goal", "rotation": 0, "size": "small"
        }
    ]
}